import { render } from "./OrLogo.vue?vue&type=template&id=40b1e26f&ts=true"
import script from "./OrLogo.vue?vue&type=script&lang=ts"
export * from "./OrLogo.vue?vue&type=script&lang=ts"

import exportComponent from "/private/var/folders/vw/10njjg05563b0tmym_8x7zf80000gp/T/deploy/auth-ui/d0985d6e09df65345867ce0a0946a5e24bd33416/node_modules/.pnpm/vue-loader@17.0.1_@vue+compiler-sfc@3.4.35_vue@3.4.35_typescript@5.4.3__webpack@5.93.0_webpack-cli@5.1.4_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__